module.exports = zebDshVendor.emotionReact;